module.exports = __webpack_public_path__ + "media/images/Icon-people-5a1665ebf32c9f14024b01ed0f36d8b8.svg";